<div class="group2">
    <h4 *ngIf="!hidetitle"> Fact. </h4>
    <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.clt149 && common.visibleChamp.cltObj149.visible">
        <label class="col-sm-3 champ" style="padding:0px">1 Fact. par Bon :</label>
        <div class="col-sm-9 champ" style="padding-right: 0px">
            <input type="checkbox" *ngIf="common.visibleChamp.cltObj149.vision" id="checkbox-1-1 "
                class="regular-checkbox regular-checkbox-checked"
                [disabled]="!edit || (add && !common.visibleChamp.cltObj149.creation) || (!add && edit && !common.visibleChamp.cltObj149.modifiable)"
                [(ngModel)]="detail.uneFactParBon">
        </div>
    </div>

    <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.clt150 && common.visibleChamp.cltObj150.visible">
        <label class="col-sm-3 champ" style="padding:0px">Fact. Autre Client :</label>
        <div class="col-sm-9 champ" style="padding-right: 0px">
            <input type="checkbox" *ngIf="common.visibleChamp.cltObj150.vision" id="checkbox-1-1 "
                class="regular-checkbox regular-checkbox-checked"
                [disabled]="!edit || (add && !common.visibleChamp.cltObj150.creation) || (!add && edit && !common.visibleChamp.cltObj150.modifiable)"
                [(ngModel)]="detail.refactClient">
        </div>
    </div>

    <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.clt150 && common.visibleChamp.cltObj150.visible">
        <label class="col-sm-3 champ" style="padding:0px">Choix du client :</label>
        <div class="col-sm-9 champ" style="padding-right: 0px"
            [ngClass]="{ 'disabledbutton': (add && !common.visibleChamp.cltObj150.creation) || (!add && edit && !common.visibleChamp.cltObj150.modifiable)}">
            <app-autocomplete *ngIf="common.visibleChamp.cltObj150.vision" [placeholder]="''"
                (searchfunction)="searchClient($event)" (selectfunction)="detail.clientRefact = $event;"
                [results]="listClient" [highlight]="true" [active]="!detail.refactClient || !edit" [label]="''"
                [dropdownclass]="mindropdown" [selectvalue]="true" [disablefocus]="true" [id]="'modedepaie negociant '"
                [defaultselected]="detail.clientRefact ? detail.clientRefact.nom : ''"
                [activeVisibleChamp]="true"
                [visibleChamp]="common.visibleChamp.cltObj150.vision"
                [defaultsearch]="detail.clientRefact ? (detail.clientRefact.nomClient || detail.clientRefact.codeClient || detail.clientRefact.libelleObjetEntite) : ''">
            </app-autocomplete>
        </div>
    </div>

    <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.clt151 && common.visibleChamp.cltObj151.visible">
        <label class="col-sm-3 champ" style="padding:0px">Ne pas fact. Art. :</label>
        <div class="col-sm-9 champ" style="padding-right: 0px">
            <input type="checkbox" *ngIf="common.visibleChamp.cltObj151.vision" id="checkbox-1-1 "
                class="regular-checkbox regular-checkbox-checked" [(ngModel)]="nePasRefactArt"
                (ngModelChange)="detail.refactArt = !nePasRefactArt"
                [disabled]="!detail.refactClient || (add && !common.visibleChamp.cltObj151.creation) || (!add && edit && !common.visibleChamp.cltObj151.modifiable)">
        </div>
    </div>

    <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.clt152 && common.visibleChamp.cltObj152.visible">
        <label class="col-sm-3 champ" style="padding:0px">Ne pas fact. Prest. :</label>
        <div class="col-sm-9 champ" style="padding-right: 0px">
            <input type="checkbox" *ngIf="common.visibleChamp.cltObj152.vision" id="checkbox-1-1 "
                class="regular-checkbox regular-checkbox-checked" [(ngModel)]="nePasRefactPrest"
                (ngModelChange)="detail.refactPrest = !nePasRefactPrest"
                [disabled]="!detail.refactClient || (add && !common.visibleChamp.cltObj152.creation) || (!add && edit && !common.visibleChamp.cltObj152.modifiable)">
        </div>
    </div>

    <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.clt153 && common.visibleChamp.cltObj153.visible">
        <label class="col-sm-3 champ" style="padding:0px">Valeurs Indices :</label>
        <div class="col-sm-9 champ text-underline historique" style="padding-right: 0px"
            *ngIf="common.visibleChamp.cltObj153.vision"
            [ngClass]="{'disabledbutton': !edit || add  || (add && !common.visibleChamp.cltObj153.creation) || (!add && edit && !common.visibleChamp.cltObj153.modifiable)}"
            (click)="showValeursIndices()">
            Modifier
        </div>
    </div>

    <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.clt112 && common.visibleChamp.cltObj112.visible">
        <label class="col-sm-3 champ" style="padding:0px"> Libellés Négo. :</label>
        <div class="col-sm-9 champ text-underline historique" style="padding-right: 0px"
            *ngIf="common.visibleChamp.cltObj112.vision"
            [ngClass]="{'disabledbutton': !edit || (add && !common.visibleChamp.cltObj112.creation) || (!add && edit && !common.visibleChamp.cltObj112.modifiable)}"
            (click)="showLibelleNego()">
            Afficher
        </div>
    </div>
</div>

<ng-template #dialogueListePeriode>
    <div class="modal-header">
        <h4 class="modal-title pull-left">Liste de périodes </h4>
        <button type="button" class="close pull-right" aria-label="Close" (click)="common.closeModal()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body" style="height: auto">
        <div>
            <ngx-datatable style="height: 100%" class="material document" [rows]="listPeriodes || []" [columnMode]="'force'"
                [headerHeight]="40" [footerHeight]="0" [rowHeight]="40" [selectionType]="'checkbox'"
                [messages]="{emptyMessage: loadingIndicator ? 'Chargement ...' : 'Pas de lignes à afficher'}"
                [loadingIndicator]="loadingIndicator" [scrollbarV]="true">
                <ngx-datatable-column name="dateDebut" prop="dateDebut">
                    <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected"
                        let-selectFn="selectFn" let-sort="sortFn">
                        <div class="tableheader">
                            <span class="uppercase"> Date début </span>
                        </div>
                    </ng-template>
                    <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                        <div class="strong">
                            {{value.slice(0, -9) || ''}}
                        </div>
                    </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column name="dateFin" prop="dateFin">
                    <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected"
                        let-selectFn="selectFn" let-sort="sortFn">
                        <div class="tableheader">
                            <span class="uppercase"> Date fin </span>
                        </div>
                    </ng-template>
                    <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                        <div class="strong">
                            {{value.slice(0, -9) || ''}}
                        </div>
                    </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column [width]="150" [sortable]="false" [canAutoResize]="false" [draggable]="false"
                    [resizeable]="false">
                    <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-row="row">
                        <div class="text-right" style="padding-right: 5px;">
                            <button class="btn-detail" (click)="showDetail(row)">
                                <i class="fa fa-pencil"></i>
                            </button>
                        </div>
                    </ng-template>
                </ngx-datatable-column>
            </ngx-datatable>
        </div>

        <div class="text-right" style="margin-top: 15px;">
            <button type="button" class="btn-close" (click)="common.closeModal()"> Annuler </button>
            <button type="button" class="btn-valider" (click)="ajouterPeriode()"> Ajouter période </button>
        </div>
    </div>
</ng-template>

<ng-template #msg>
    <div class="modal-body" style="height: auto">
        <div>
            <div class="col-sm-12">
                <label class="cofirmemsg" [innerHTML]="error"> </label>
            </div>
        </div>
        <div class="text-right" style="margin-top: 15px;">
            <button type="button" class=" btn-close btn-valider" (click)="error = ''; common.closeModal()"> Fermer
            </button>
        </div>
    </div>
</ng-template>

<ng-template #dialogueValeursIndices>
    <div class="modal-header">
        <h4 class="modal-title pull-left">Valeurs des indices </h4>
        <button type="button" class="close pull-right" aria-label="Close" (click)="common.closeModal()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body" style="height: auto">
        <div class="col-sm-4" style="padding: 5px 0;">
            <div class="col-sm-12" style=" padding: 0 5px; margin-bottom: 5px">
                <label class="col-sm-4 title"> Date début</label>
                <div class="col-sm-7" style=" padding: 0 5px;">
                    <app-input-date [class]="'form-control fieldDateIndice'" [id]="'dateDebut'"
                        [placeholder]="'Date debut'" [model]="dateDebut" [closeDatepickerOnSelect]="true"
                        (changefct)="changeDate($event)" [showDatepicker]="true" [container]="true" [dateVide]="true">
                    </app-input-date>
                </div>
            </div>
            <div class="col-sm-12" style=" padding: 0 5px;">
                <label class="col-sm-4 title"> Date fin </label>
                <div class="col-sm-7" style=" padding: 0 5px;">
                    <app-input-date [class]="'form-control fieldDateIndice'" [id]="'datefin'" [placeholder]="'Date fin'"
                        [model]="dateFin" [closeDatepickerOnSelect]="true" (changefct)="changeDate($event, true)"
                        [showDatepicker]="true" [container]="true" [dateVide]="true">
                    </app-input-date>
                </div>
            </div>
        </div>
        <div>
            <ngx-datatable style="height: 100%" class="material document" [rows]="listValeursIndices || []"
                [columnMode]="'force'" [headerHeight]="40" [footerHeight]="0" [rowHeight]="40"
                [selectionType]="'checkbox'"
                [messages]="{emptyMessage: loadingIndicator ? 'Chargement ...' : 'Pas de lignes à afficher'}"
                [loadingIndicator]="loadingIndicator" [scrollbarV]="true">
                <ngx-datatable-column name="indiceLibelle" prop="indice.libelle">
                    <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected"
                        let-selectFn="selectFn" let-sort="sortFn">
                        <div class="tableheader">
                            <span class="uppercase"> Nom indice </span>
                        </div>
                    </ng-template>
                    <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                        <div class="strong">
                            {{value}}
                        </div>
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="indiceVariable" prop="indice.nomVariable">
                    <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected"
                        let-selectFn="selectFn" let-sort="sortFn">
                        <div class="tableheader">
                            <span class="uppercase"> Nom variable </span>
                        </div>
                    </ng-template>
                    <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                        <div class="strong">
                            {{value}}
                        </div>
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column prop="chantier.libelleObjetEntite">
                    <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected"
                        let-selectFn="selectFn" let-sort="sortFn">
                        <div class="tableheader">
                            <span class="uppercase"> Chantier </span>
                        </div>
                    </ng-template>
                    <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                        <div class="strong">
                            {{ value }}
                        </div>
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column prop="agence.libelleObjetEntite">
                    <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected"
                        let-selectFn="selectFn" let-sort="sortFn">
                        <div class="tableheader">
                            <span class="uppercase"> Chantier </span>
                        </div>
                    </ng-template>
                    <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                        <div class="strong">
                            {{ value }}
                        </div>
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="valeur">
                    <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected"
                        let-selectFn="selectFn" let-sort="sortFn">
                        <div class="tableheader">
                            <span class="uppercase"> Valeur </span>
                        </div>
                    </ng-template>
                    <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                        <div class="strong">
                            <input type="number" class="form-control" [(ngModel)]="row.valeur">
                        </div>
                    </ng-template>
                </ngx-datatable-column>
            </ngx-datatable>
        </div>

        <div class="text-right" style="margin-top: 15px;">
            <button type="button" class="btn-close" (click)="common.closeModal()"> Annuler </button>
            <button type="button" class="btn-valider" (click)="saveValeursIndices()"> Valider </button>
        </div>
    </div>
</ng-template>